<template>
  <div class="part-item projectBuilding">
    <p class="part-title">实验教学在线支持与服务
      <a
        v-show="isShow"
        href="javascript:;"
        @click="clearItem('teach')"
      ><i class="icon iconfont">&#xe614;</i>清空</a>
      <a
        v-show="isShow"
        href="javascript:;"
        @click="openTeach"
      ><i class="icon iconfont">&#xe660;</i>编辑</a>
    </p>
    <div class="part-content">
      <span class="content-title">(1) 教学指导资源：</span>
      <div
        class="content-text"
        v-if="formInfo.online_support"
      >
        <div
          v-for="(item,index) in formInfo.online_support.teachChild"
          :key="index+'teach'"
        >
          <div
            class="teachItem"
            v-show="item.isSelect"
          >
            <p>{{item.title}}：</p>
            <a
              target="_blank"
              :href="file?file.path:'javascript:;'"
              :download="file?file.name:''"
              v-for="(file,key) in item.fileArry"
              :key="index + '-'+ key"
              class="link"
            >{{file.name}}</a>
          </div>
        </div>
      </div>
      <div
        class="content-text"
        v-else
      >暂无内容，请进行维护</div>
      <div class="clearfix"></div>
      <span class="content-title">(2) 实验指导资源：</span>
      <div
        class="content-text"
        v-if="formInfo.online_support"
      >
        <div
          v-for="(item,index) in formInfo.online_support.expChild"
          :key="index+'exp'"
        >
          <div
            class="teachItem"
            v-show="item.isSelect"
          >
            <p>{{item.title}}：</p>
            <template v-if="item.type==1">
              <a
                v-for="(file,key) in item.fileArry"
                :key="index + '-'+ key"
                class="link"
                :href="file?file.path:'javascript:;'"
                target="_blank"
                :download="file?file.name:''"
              >{{file.name}}</a>
            </template>
            <template v-if="item.type==2">
              <a
                :href="item.link"
                target="_blank"
                class="link"
              >{{item.link}}</a>
            </template>
          </div>
        </div>
      </div>
      <div
        class="content-text"
        v-else
      >暂无内容，请进行维护</div>
      <div class="clearfix"></div>
      <span class="content-title">(3) 在线教学支持方式：</span>
      <div
        class="content-text"
        v-if="formInfo.online_support"
      >
        <div
          v-for="(item,index) in formInfo.online_support.onlineteachChild"
          :key="index+'online'"
        >
          <div v-show="item.isSelect">
            <span>{{item.title}}：</span>
            <template v-if="item.type==1">
              <span>{{item.link}}</span>
            </template>
            <template v-else>
              <span style="margin-right:10px">{{item.link1}}</span>
              <span>{{item.link2}}</span>
            </template>
          </div>
        </div>
      </div>
      <div
        v-else
        class="content-text"
      >暂无内容，请进行维护</div>
      <div class="clearfix"></div>
      <span class="content-title">(4) <span class="NumCount">{{formInfo.online_support?formInfo.online_support.team:0}}</span>名提供在线教学服务的团队成员；<span class="NumCount">{{formInfo.online_support?formInfo.online_support.skill:0}}</span>名提供在线技术支持的技术人员；教学团队保证工作日期间提供<span class="NumCount">{{formInfo.online_support?formInfo.online_support.time:0}}</span>小时/日的在线服务</span>
      <div class="clearfix"></div>
    </div>

    <div
      id="file-upload-overlay"
      :style="showWindow.bigFile ? 'display: block' : ''"
    >
      <div class="file-upload-bg"></div>
      <div class="file-upload">
        <div
          class="file-upload-type"
          v-show="showWindow.teach"
        >允许上传的文件扩展名：{{ showWindow.bigFileOption.fileTypes }}</div>
        <div
          class="file-upload-close"
          @click="hideFileWindow"
        >×</div>
        <span
          class="file_uploadBtn"
          id="file_uploadBtn"
          style="display: block;"
        >
          选择文件<input
            type="file"
            id="file_fileInput"
            ref="docFile"
            :accept="showWindow.bigFileOption.fileTypes"
            style="display: block;"
            @change="fileChange"
          >
        </span>
        <div
          class="fileBox"
          id="file_uploadBox"
          style="display: block;"
        >
          <span
            class="pauseBtn"
            id="file_pauseBtn"
            style="display: none;"
          >暂停</span>
          <span
            class="goBtn"
            id="file_goBtn"
            style="display:none;"
          >继续</span>
          <div
            class="filename"
            id="file_filename"
            style="display: none;"
          ></div>
          <div
            class="pbar"
            :style="showWindow.bigFileOption.showProgress ? 'display: block' : 'display: none'"
          >
            <div
              class="progress"
              id="file_progress"
              :style="'width: ' + Math.ceil(showWindow.bigFileOption.progressValue * 4.2) + 'px;'"
            ></div>
            <div id="file_percent">{{ showWindow.bigFileOption.progressValue }}%</div>
          </div>
        </div>
        <div class="clear"></div>
      </div>
    </div>

    <div
      class="form_overlay"
      id="building_overlay"
      :style="formatShowWindow(showWindow.teach)"
    >
      <div class="form_overlay_bg"></div>
      <div class="form_panel editor">
        <div class="form_title">实验教学在线支持与服务</div>
        <a
          href="javascript:void(0)"
          @click="showWindow.teach = false"
          class="overlay-close"
        ><i class="iconfont"></i></a>
        <div class="form_content">
          <form id="buildingForm">
            <div class="item">
              <div class="warn">
                <div>
                  <p>注：上传的单个文件大小在1GB之内。</p>
                  <p>请勿上传侵犯他人知识产权及其他与知识产权有关的合法权利的内容；若引用地图请注意规范性、科学性与政治性；文件名应反映主题内容，尽量与文内标题保持一致，不要使用“1.doc”这类含义不明的标题。<span
                      v-show="isMore"
                      @click="isMore=!isMore"
                    >查看更多</span></p>
                </div>
                <div v-if="!isMore">
                  <p>上传内容不得出现以下情况：</p>
                  <p>（1）违反宪法或法律法规规定的；</p>
                  <p>（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>
                  <p>（3）损害国家荣誉和利益的，损害公共利益的；</p>
                  <p>（4）煽动民族仇恨、民族歧视，破坏民族团结的；</p>
                  <p>（5）破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
                  <p>（6）散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
                  <p>（7）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</p>
                  <p>（8）侮辱或者诽谤他人，侵害他人合法权益的；</p>
                  <p>（9）含有法律、行政法规禁止的其他内容的。</p>
                  <p>本网保留对不符合规定的内容采取相应处理措施的权力。<span
                      v-show="!isMore"
                      @click="isMore=!isMore"
                    >收起</span></p>
                </div>
              </div>
            </div>
            <div class="item">
              <span class="label"><i class="require"></i>教学指导资源</span>
              <div style="float: left;">
                <div
                  class="teachEdit"
                  v-for="(item,index) in formTeach.teachChild"
                  :key="index"
                >
                  <label class="m-r">
                    <input
                      v-model="item.isSelect"
                      type="checkbox"
                    >{{item.title}}</label>
                  <template v-if="item.isSelect">
                    <div
                      class="file"
                      v-for="(file,key) in item.fileArry"
                      :key="index + '-' + key"
                    >
                      <a>
                        {{file.name}}
                      </a>
                      <span
                        class="del"
                        @click="delSubject(1,index,key)"
                      >
                        x
                      </span>
                    </div>
                  </template>
                  <span
                    v-show="item.isSelect"
                    @click="showFileWindow(item.fileType),teachType=1,teachIndex=index"
                    class="upload"
                  >上传</span>
                </div>
              </div>
            </div>
            <div class="item">
              <span class="label"><i class="require"></i>实验指导资源</span>
              <div style="float: left;">
                <div
                  class="teachEdit"
                  v-for="(item,index) in formTeach.expChild"
                  :key="index"
                >
                  <label class="m-r">
                    <input
                      v-model="item.isSelect"
                      type="checkbox"
                    >{{item.title}}</label>
                  <template v-if="item.isSelect">
                    <div
                      class="file"
                      v-for="(file,key) in item.fileArry"
                      :key="index + '-' + key"
                    >
                      <a>
                        {{file.name}}
                      </a>
                      <span
                        class="del"
                        @click="delSubject(2,index,key)"
                      >
                        x
                      </span>
                    </div>
                  </template>
                  <span
                    v-show="item.isSelect && item.type==1"
                    @click="showFileWindow(item.fileType),teachType=2,teachIndex=index"
                    class="upload"
                  >上传</span>
                  <input
                    v-show="item.isSelect && item.type == 2"
                    placeholder="请输入网址"
                    v-model="item.link"
                    type="text"
                    maxlength="25"
                  >
                </div>
              </div>
            </div>
            <div class="item">
              <span class="label"><i class="require"></i>在线教学支持方式</span>
              <div style="float: left;">
                <div
                  class="teachEdit"
                  v-for="(item,index) in formTeach.onlineteachChild"
                  :key="index"
                >
                  <label class="m-r">
                    <input
                      :disabled="index == 0"
                      v-model="item.isSelect"
                      type="checkbox"
                    >{{item.title}}</label>
                  <div
                    style="display: inline-block;"
                    v-show="item.isSelect && item.type == 2"
                  >
                    <input
                      style="width:150px;margin-right:20px;"
                      v-model="item.link1"
                      type="text"
                      maxlength="25"
                    >
                    <input
                      style="width:150px"
                      v-model="item.link2"
                      type="text"
                      maxlength="25"
                    >
                  </div>
                  <input
                    v-show="item.isSelect && item.type == 1"
                    v-model="item.link"
                    type="text"
                    maxlength="25"
                  >
                </div>
              </div>
            </div>
            <div class="item">
              <div class="teach_Item">
                <input
                  type="text"
                  class="text"
                  maxlength="25"
                  v-model="formTeach.team"
                >名提供在线教学服务的团队成员；<input
                  type="text"
                  class="text"
                  maxlength="25"
                  v-model="formTeach.skill"
                >名提供在线技术支持的技术人员；教学团队保证工作日期间提供<input
                  type="text"
                  class="text"
                  maxlength="10"
                  v-model="formTeach.time"
                >小时/日的在线服务
              </div>
            </div>
          </form>
        </div>
        <div class="form_control">
          <a
            href="javascript:;"
            @click="showWindow.teach = false"
            class="button close"
            id="building_close"
          >取消</a>
          <a
            href="javascript:;"
            @click="saveTeach(1)"
            class="button"
            id="building_submit"
          >提交</a>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'ExperimentMaintainSupport',
  props: ['isShow', 'expId'],
  data() {
    return {
      showWindow: {
        teach: false,
        bigFile: false,
        bigFileOption: {
          showProgress: false,
          progressValue: 0,
          fileTypes: '*'
        }
      },
      isMore: true,
      formInfo: {},
      formTeach: {
        teachChild: [
          { title: '教学指导书', isSelect: false, fileArry: [], fileType: '.pdf,.doc,.docx,.ppt,.pptx' },
          { title: '教学视频', isSelect: false, fileArry: [], fileType: '.mp4' },
          { title: '教学电子教材', isSelect: false, fileArry: [], fileType: '.mp4,.pdf,.ppt,.pptx' },
          { title: '教学课程教案', isSelect: false, fileArry: [], fileType: '.pdf,.doc,.docx,.ppt,.pptx' },
          { title: '课件（演示文稿）', isSelect: false, fileArry: [], fileType: '.pdf,.doc,.docx,.ppt,.pptx' },
          { title: '其他', isSelect: false, fileArry: [], fileType: '.pdf,.doc,.docx,.jpg,.png,.ppt,.pptx' }
        ],
        expChild: [
          { title: '实验指导书', type: 1, isSelect: false, fileArry: [], fileType: '.pdf,.doc,.docx,.ppt,.pptx' },
          { title: '操作视频', type: 1, isSelect: false, fileArry: [], fileType: '.mp4,.ppt,.pptx' },
          { title: '知识点课件库', type: 2, isSelect: false, link: '' },
          { title: '习题库', type: 2, isSelect: false, link: '' },
          { title: '测试卷', type: 1, isSelect: false, fileArry: [], fileType: '.doc,.docx,.pdf,.ppt,.pptx' },
          { title: '测试系统', type: 2, isSelect: false, link: '' },
          { title: '其他', type: 1, isSelect: false, fileArry: [], fileType: '.pdf,.doc,.docx,.jpg,.png,.ppt,.pptx' }
        ],
        onlineteachChild: [
          { title: '热线电话', type: 2, isSelect: true, link1: '', link2: '' },
          { title: '实验系统即时通讯', type: 1, isSelect: false, link: '' },
          { title: '论坛', type: 1, isSelect: false, link: '' },
          { title: '支持与服务群', type: 1, isSelect: false, link: '' },
          { title: '其他', type: 2, isSelect: false, link1: '', link2: '' }
        ],
        team: '',
        skill: '',
        time: ''
      }
    }
  },
  methods: {
    formatShowWindow(tag) {
      if (tag) {
        return {
          visibility: 'visible'
        }
      } else {
        return {}
      }
    },
    async getInfo() {
      const url = '/allowany/experiment/' + this.expId + '/'
      await this.$http.get(url).then(async (data) => {
        this.formInfo = data
        this.formInfo.online_support = data.online_support ? JSON.parse(data.online_support) : ''
      }).catch((error) => {
        console.log(error)
      })
    },
    openTeach() {
      if (this.formInfo.online_support) {
        this.formTeach = JSON.parse(JSON.stringify(this.formInfo.online_support))
      } else {
        this.formTeach = {
          teachChild: [
            { title: '教学指导书', isSelect: false, fileArry: [], fileType: '.pdf,.doc,.docx,.ppt,.pptx' },
            { title: '教学视频', isSelect: false, fileArry: [], fileType: '.mp4' },
            { title: '教学电子教材', isSelect: false, fileArry: [], fileType: '.mp4,.pdf,.ppt,.pptx' },
            { title: '教学课程教案', isSelect: false, fileArry: [], fileType: '.pdf,.doc,.docx,.ppt,.pptx' },
            { title: '课件（演示文稿）', isSelect: false, fileArry: [], fileType: '.pdf,.doc,.docx,.ppt,.pptx' },
            { title: '其他', isSelect: false, fileArry: [], fileType: '.pdf,.doc,.docx,.jpg,.png,.ppt,.pptx' }
          ],
          expChild: [
            { title: '实验指导书', type: 1, isSelect: false, fileArry: [], fileType: '.pdf,.doc,.docx,.ppt,.pptx' },
            { title: '操作视频', type: 1, isSelect: false, fileArry: [], fileType: '.mp4,.ppt,.pptx' },
            { title: '知识点课件库', type: 2, isSelect: false, link: '' },
            { title: '习题库', type: 2, isSelect: false, link: '' },
            { title: '测试卷', type: 1, isSelect: false, fileArry: [], fileType: '.doc,.docx,.pdf,.ppt,.pptx' },
            { title: '测试系统', type: 2, isSelect: false, link: '' },
            { title: '其他', type: 1, isSelect: false, fileArry: [], fileType: '.pdf,.doc,.docx,.jpg,.png,.ppt,.pptx' }
          ],
          onlineteachChild: [
            { title: '热线电话', type: 2, isSelect: true, link1: '', link2: '' },
            { title: '实验系统即时通讯', type: 1, isSelect: false, link: '' },
            { title: '论坛', type: 1, isSelect: false, link: '' },
            { title: '支持与服务群', type: 1, isSelect: false, link: '' },
            { title: '其他', type: 2, isSelect: false, link1: '', link2: '' }
          ],
          team: '',
          skill: '',
          time: ''
        }
      }
      this.showWindow.teach = true
    },
    showFileWindow(fileType) {
      if (this.isShow) {
        this.showWindow.bigFile = true
        this.showWindow.bigFileOption.fileTypes = fileType
      }
    },
    hideFileWindow() {
      this.showWindow.bigFile = false
    },
    async fileChange() {
      if (this.$store.state.max_file_size && this.$refs.docFile.files[0].size > this.$store.state.max_file_size) {
        alert('文件大小超过限制！')
        return false
      }
      this.showWindow.bigFileOption.showProgress = true
      const fileRealName = this.$refs.docFile.files[0].name
      const uploadUrl = '/info_files/' + fileRealName
      await this.$http.put(uploadUrl, this.$refs.docFile.files[0], {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: (e) => {
          this.showWindow.bigFileOption.progressValue = Math.ceil(e.loaded / e.total * 100)
        }
      }).then((data) => {
        this.showWindow.bigFileOption.showProgress = false
        this.showWindow.bigFileOption.progressValue = 0
        this.hideFileWindow()

        // 此处处理data
        if (this.showWindow.teach) {
          if (this.teachType === 1) {
            this.formTeach.teachChild[this.teachIndex].fileArry.push({
              name: this.$refs.docFile.files[0].name,
              path: data
            })
          } else {
            this.formTeach.expChild[this.teachIndex].fileArry.push({
              name: this.$refs.docFile.files[0].name,
              path: data
            })
          }
        }
      }).catch((error) => {
        console.log(error)
        this.showWindow.bigFileOption.showProgress = false
        this.showWindow.bigFileOption.progressValue = 0
        this.hideFileWindow()
        this.$layer.msg('上传失败！')
      })
    },
    async saveTeach(type) {
      const url = '/experiment/' + this.expId + '/'
      await this.$http.put(url, {
        online_support: type ? JSON.stringify(this.formTeach) : ''
      }).then((data) => {
        if (data.id) {
          this.formInfo.online_support = type ? JSON.parse(data.online_support) : ''
          this.showWindow.teach = false
        } else {
          this.$layer.msg('修改失败！')
        }
      }).catch((error) => {
        console.log(error)
        this.$layer.msg('修改失败！')
      })
    },
    clearItem(categgory) {
      switch (categgory) {
        case 'teach':
          // this.formProj = {
          //   proj_situation_online_time: '',
          //   proj_situation_open_time: '',
          //   proj_situation_student_count: '',
          //   proj_situation_social: 0
          // }
          this.saveTeach(0)
          break
      }
    },
    delSubject(type, index, i) {
      if (type === 1) {
        this.formTeach.teachChild[index].fileArry.splice(i, 1)
      } else {
        this.formTeach.expChild[index].fileArry.splice(i, 1)
      }
    }
  },
  async mounted() {
    await this.getInfo()
  }
}
</script>
<style scoped src="../../../../assets/css/project-detail.css"></style>
<style scoped src="../../../../assets/css/table.css"></style>
<style scoped src="../../../../assets/css/chunkUpload.css"></style>
<style scoped src="../../../../assets/css/project-manage.css"></style>
<style lang="less" scoped>
.content .container {
  width: 1200px;
  margin: 0 auto;
  visibility: visible;
}

.center_content {
  .box-wrap {
    margin-top: 20px;
    padding: 40px;
    background: #fff;
    box-sizing: border-box;
  }

  .title {
    height: 50px;
    line-height: 50px;
    font-size: 20px;
    font-weight: bold;
    border-bottom: 1px solid #eee;
    position: relative;
    padding-right: 160px;
    padding-left: 20px;

    .title-btns {
      position: absolute;
      top: 0;
      right: 0;

      > a {
        margin-right: 10px;
        font-size: 14px;
        font-weight: lighter;
        color: #3399ff;
        cursor: pointer;

        i {
          font-size: 14px;
          margin-right: 5px;
        }
      }
    }
  }

  .title:before {
    content: "";
    width: 4px;
    height: 1em;
    background-color: #73D6CA;
    position: absolute;
    left: 0;
    top: 16px;
  }

  .mbox .lBox {
    float: left;
    width: 600px;

    .detail-base {
      font-size: 16px;
      padding: 20px 0;
      height: 376px;
      box-sizing: border-box;
      overflow-y: auto;

      .detail-item {
        display: inline-block;
        margin-right: 30px;
        padding: 10px 0;
      }

      .detail-intro {
        padding: 10px 0;

        .label {
          float: left;
        }

        p {
          padding-left: 80px;
        }
      }

      .clearfix:after {
        content: ".";
        display: block;
        height: 0;
        clear: both;
        visibility: hidden;
        overflow: hidden;
      }
    }
  }

  .label {
    width: 100px;
    padding-right: 10px;
  }

  .mbox .rBox {
    float: right;
    width: 460px;

    .preview {
      padding: 6px 20px;
      border: 1px solid #73D6CA;
      color: #73D6CA;
      border-radius: 3px;
    }

    .submit {
      padding: 7px 20px;
      background: #73D6CA;
      color: #fff;
      border-radius: 3px;
    }

    .imgCover {
      width: 100%;
      height: 306px;
      margin-top: 10px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .upload {
      width: 140px;
      height: 40px;
      line-height: 40px;
      display: block;
      margin: 10px auto;
      text-align: center;
      background: #21b295;
      color: #fff;
      border-radius: 3px;
      cursor: pointer;
      font-size: 16px;
    }
  }
  .part-content {
    .part-new-table {
      margin: 10px 0;
      border: 1px solid #ebebeb;
      width: 100%;
      max-width: 100%;
      border-spacing: 0;
      border-collapse: collapse;
      background-color: transparent;
      tr th {
        background-color: #f8faff;
        color: #999;
        font-weight: normal;
      }
    }
    .part-new-table tr th,
    .part-new-table tr td {
      padding: 8px;
      line-height: 1.42857143;
      vertical-align: middle;
      border: 1px solid #ebebeb;
      text-align: center;
    }
  }
  .item-box {
    float: left;
    width: 302px;
    position: relative;
  }

  .uploadImgPreview li img {
    width: 100%;
    margin-top: 5px;
  }

  .clearfix:after {
    content: ".";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
    overflow: hidden;
  }

  .video-box {
    .lBox {
      float: left;
      width: 500px;

      .upload {
        padding: 6px 20px;
        background: #73D6CA;
        color: #fff;
        border-radius: 3px;
      }
    }

    .video-wrap {
      width: 400px;
      height: 226px;
      margin: 10px auto 0;
      background: #000;

      video {
        width: 100%;
        height: 100%;
      }
    }

    .rBox {
      float: right;
      width: 500px;

      .upload {
        padding: 6px 20px;
        background: #73D6CA;
        color: #fff;
        border-radius: 3px;
      }
    }
  }

  .menu-box {
    overflow: hidden;
    border-bottom: 1px solid #eee;

    ul {
      li {
        text-align: center;
        float: left;
        margin-right: 10px;

        a {
          display: block;
          padding: 10px;
          font-size: 16px;
          color: #002900;
          text-decoration: none;
          border-bottom: 3px solid #fff;
        }

        &:hover a {
          color: #73D6CA;
          border-color: #73D6CA;
        }
      }

      .onActive {
        a {
          color: #73D6CA;
          border-color: #73D6CA;
        }
      }
    }
  }

  .part {
    min-height: 390px;
    margin-top: 30px;
  }
}
.form_contentEdit .label {
  width: 100px !important;
}
.form_content .k-container {
  max-width: 640px;
  width: 640px;
  .item-table {
    width: 640px;
    input {
      width: 100%;
      border: none;
    }
  }
  .item-table th,
  .item-table td {
    border-bottom: 1px solid #ddd;
    border-right: 1px solid #ddd;
    text-align: center;
    padding-bottom: 1px;
  }
}
.teachItem {
  p {
    font-weight: 600;
  }
  .link {
    color: #0b80ff;
    margin: 10px 0;
    display: block;
  }
}
.teachEdit {
  .m-r {
    color: #333333;
    font-weight: 500;
    display: inline-block;
    width: 150px;
    input {
      position: relative;
      top: -1px;
      margin-right: 7px;
    }
  }
  .file {
    color: #0b80ff;
    display: block;
    .del {
      margin-left: 10px;
      font-size: 22px;
      color: #c7254e;
      cursor: pointer;
      margin: 0;
      background: transparent;
      top: 3px;
      position: relative;
    }
  }
  .upload {
    display: block;
    text-align: center;
    width: 55px;
    line-height: 30px;
    background: #f19830;
    color: #fff;
    cursor: pointer;
  }
}
.warn {
  p {
    font-size: 12px;
    color: #df3d3e;
  }
  span {
    font-size: 12px;
    color: #337ab7;
    cursor: pointer;
  }
}
.NumCount {
  display: inline-block;
  text-align: center;
  width: 40px;
  border-bottom: 1px solid #999;
}
.teach_Item {
  color: #666;
  .text {
    width: 40px !important;
    height: 20px !important ;
    line-height: 23px !important;
    border: none !important;
    text-align: center;
    border-bottom: 1px solid #999 !important;
  }
}
.form_overlay {
  z-index: 100 !important;
}

.file-upload {
  z-index: 200 !important;
}

.menu-list > li.on a,
.menu-list > li:hover a {
  color: #73D6CA !important;
  border-color: #73D6CA !important;
}
.signPic {
  max-height: 20px;
  max-width: 120px;
  vertical-align: middle;
  display: inline-block;
  margin-top: -3px;
  margin-right: 25px;
}
.del-icon {
  color: #ff0000;
  position: relative;
  display: inline-block;
  border: 1px solid #ddd;
  font-size: 12px;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  border-radius: 20px;
  right: 17px;
  top: -12px;
  cursor: pointer;
}
.url_link {
  flex: 1;
  overflow-x: auto;
  white-space: nowrap;
}
.url_link::-webkit-scrollbar {
  display: none;
}
.form_control {
  text-align: center;
}
.form_control a {
  float: none;
  display: inline-block;
}
.addOtherUser {
  display: inline-block;
  color: #ffffff;
  margin-left: 15px;
  height: 34px;
  line-height: 34px;
  padding: 0 15px;
  border-radius: 4px;
  background-color: #028c8c;
  border-color: #028c8c;
  cursor: pointer;
}
.infor span {
  font-size: 14px;
  color: #333;
  margin-right: 20px;
  display: inline-block;
  margin-bottom: 10px;
  display: inline-block;
}
.infor span i {
  color: #999;
}
.person {
  position: relative;
  overflow: hidden;
}
.person_symbol {
  position: absolute;
  left: -20px;
  top: 4px;
  background: #ff2424;
  color: #fff;
  width: 70px;
  text-align: center;
  font-size: 12px;
  transform: rotate(-45deg);
  -ms-transform: rotate(-45deg); /* Internet Explorer 9*/
  -moz-transform: rotate(-45deg); /* Firefox */
  -webkit-transform: rotate(-45deg); /* Safari 和 Chrome */
  -o-transform: rotate(-45deg); /* Opera */
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);
}
</style>
